import { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { getComentariosCotizacion, guardarComentarioCotizacion } from "../Integracion";


const ETIQUETAS = {
    NUEVO: 'Nuevo',
    PLANEACION: 'En planeación',
    COSTEO: 'En costeo / Costeado',
    APROBADO: 'Aprobado',
};

const SECCION_POR_ESTATUS = {
    1: 'NUEVO',
    2: 'PLANEACION',
    3: 'COSTEO',
    9: 'COSTEO',
    5: 'APROBADO',
};

const ComentariosCotizacion = ({ idCotizacion, idUsuario, estatus }) => {
    const [comentarios, setComentarios] = useState([]);
    const [borradores, setBorradores] = useState({});
    const [visible, setVisible] = useState(false);
    const [guardando, setGuardando] = useState(null);
    const [error, setError] = useState('');

    const seccionActual = SECCION_POR_ESTATUS[estatus];

    const cargar = async () => {
        const data = await getComentariosCotizacion(idCotizacion, idUsuario);
        setComentarios(data);
        setBorradores(Object.fromEntries(data.map(c => [c.seccion, c.comentario ?? ''])));
    };

    useEffect(() => {
        if (idCotizacion && idUsuario) cargar();
    }, [idCotizacion, idUsuario]);

    const guardar = async (seccion) => {
        setGuardando(seccion);
        setError('');
        try {
            await guardarComentarioCotizacion(idCotizacion, seccion, borradores[seccion], idUsuario);
            await cargar();
        } catch (e) {
            setError(e.response?.data?.message ?? 'No se pudo guardar');
        } finally {
            setGuardando(null);
        }
    };

    const total = comentarios.filter(c => c.comentario).length;

    return (
        <>
            <Button
                icon="pi pi-comments"
                label="Comentarios"
                className="p-button-sm"
                outlined={!total}
                badge={total ? String(total) : null}
                onClick={() => setVisible(true)}
                aria-label={`Comentarios (${total})`}
            />

            <Dialog
                header="Comentarios por estatus"
                visible={visible}
                onHide={() => setVisible(false)}
                style={{ width: '40rem' }}
                breakpoints={{ '640px': '95vw' }}
            >
                {comentarios.map(c => (
                    <div key={c.seccion} className="mb-4">
                        <label htmlFor={`com-${c.seccion}`} className="block font-semibold mb-2">
                            {ETIQUETAS[c.seccion]}
                        </label>

                        {c.puedeEditar && c.seccion === seccionActual ? (
                            <>
                                <InputTextarea
                                    id={`com-${c.seccion}`}
                                    value={borradores[c.seccion]}
                                    onChange={e => setBorradores({ ...borradores, [c.seccion]: e.target.value })}
                                    rows={3}
                                    autoResize
                                    className="w-full"
                                />
                                <div className="flex justify-content-end mt-2">
                                    <Button
                                        label="Guardar"
                                        size="small"
                                        loading={guardando === c.seccion}
                                        disabled={!borradores[c.seccion]?.trim()}
                                        onClick={() => guardar(c.seccion)}
                                    />
                                </div>
                            </>
                        ) : (
                            <p className="m-0 text-700 white-space-pre-line">
                                {c.comentario || 'Sin comentario'}
                            </p>
                        )}

                        {c.fecha && (
                            <small className="text-500">
                                {new Date(c.fecha).toLocaleString('es-MX')}
                            </small>
                        )}
                    </div>
                ))}

                {error && <small className="p-error">{error}</small>}
            </Dialog>
        </>
    );
};

export default ComentariosCotizacion;
